// import React, { useState, useEffect } from 'react'
// import { useNavigate } from 'react-router-dom'
// import * as api from '../../../app/axios/api'
// import { toast } from 'sonner'

// import {
//   Users,
//   IndianRupee,
//   Activity,
//   Search,
//   ChevronLeft,
//   ChevronRight,
//   Eye,
//   Edit,
//   UserCheck,
//   Filter,
//   Download,
//   X, // Close icon for modal
// } from 'lucide-react'

// const SummerDashboard = () => {
//   const navigate = useNavigate()

//   const [registrations, setRegistrations] = useState([])
//   const [loading, setLoading] = useState(true)
//   const [error, setError] = useState(null)

//   // Filters, Search, aur Pagination States
//   const [searchTerm, setSearchTerm] = useState('')
//   const [statusFilter, setStatusFilter] = useState('all')
//   const [modeFilter, setModeFilter] = useState('all')

//   const [currentPage, setCurrentPage] = useState(1)
//   const itemsPerPage = 20

//   // --- EDIT MODAL STATES ---
//   const [isEditModalOpen, setIsEditModalOpen] = useState(false)
//   const [editingStudent, setEditingStudent] = useState(null)
//   const [isUpdating, setIsUpdating] = useState(false)

//   // API Call
//   const loadDashboardData = async () => {
//     setLoading(true)
//     setError(null)
//     try {
//       const res = await api.fetchSummerDashboard()
//       setRegistrations(res.data || [])
//     } catch (err) {
//       console.error('Error fetching summer dashboard:', err)
//       setError('Failed to load registration data. Please try again later.')
//     } finally {
//       setLoading(false)
//     }
//   }

//   useEffect(() => {
//     loadDashboardData()
//   }, [])

//   useEffect(() => {
//     setCurrentPage(1)
//   }, [searchTerm, statusFilter, modeFilter])

//   // --- Search & Filter Logic ---
//   const filteredRegistrations = registrations.filter((student) => {
//     const searchString = searchTerm.toLowerCase()
//     const matchesSearch =
//       student.name?.toLowerCase().includes(searchString) ||
//       student.course_code?.toLowerCase().includes(searchString) ||
//       student.phone_number?.includes(searchString) ||
//       student.registration_no?.toLowerCase().includes(searchString) ||
//       student.college?.toLowerCase().includes(searchString) ||
//       student.razorpay_payment_id?.toLowerCase().includes(searchString)

//     const matchesStatus =
//       statusFilter === 'all' || student.status?.toLowerCase() === statusFilter

//     const matchesMode =
//       modeFilter === 'all' ||
//       student.training_mode?.toLowerCase() === modeFilter

//     return matchesSearch && matchesStatus && matchesMode
//   })

//   // --- CSV Export Logic ---
//   const downloadCSV = () => {
//     if (filteredRegistrations.length === 0) {
//       alert('No data available to download')
//       return
//     }

//     const headers = [
//       'Student Name',
//       'Registration No',
//       'Phone Number',
//       'Father Name',
//       'Course Code',
//       'Mode',
//       'Registration Fee',
//       'Total Fee',
//       'Date',
//       'Status',
//       'Gender',
//     ]

//     const rows = filteredRegistrations.map((student) => [
//       student.name || '',
//       student.registration_no || '',
//       student.phone_number || '',
//       student.father_name || '',
//       student.course_code || '',
//       student.training_mode || '',
//       student.registration_fee || 0,
//       student.fee || 0,
//       new Date(student.created_at).toLocaleDateString('en-IN', {
//         day: '2-digit',
//         month: 'short',
//         year: 'numeric',
//       }),
//       student.status || 'Pending',
//       student.gender || '',
//     ])

//     const csvContent = [
//       headers.join(','),
//       ...rows.map((row) => row.map((value) => `"${value}"`).join(',')),
//     ].join('\n')

//     const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
//     const url = URL.createObjectURL(blob)
//     const link = document.createElement('a')
//     link.setAttribute('href', url)
//     link.setAttribute(
//       'download',
//       `Summer_Registrations_${new Date().toISOString().split('T')[0]}.csv`,
//     )
//     link.style.visibility = 'hidden'
//     document.body.appendChild(link)
//     link.click()
//     document.body.removeChild(link)
//   }

//   // --- Pagination Logic ---
//   const indexOfLastItem = currentPage * itemsPerPage
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage
//   const currentItems = filteredRegistrations.slice(
//     indexOfFirstItem,
//     indexOfLastItem,
//   )
//   const totalPages = Math.ceil(filteredRegistrations.length / itemsPerPage)

//   const handleNextPage = () => {
//     if (currentPage < totalPages) setCurrentPage((prev) => prev + 1)
//   }
//   const handlePrevPage = () => {
//     if (currentPage > 1) setCurrentPage((prev) => prev - 1)
//   }

//   // --- EDIT MODAL LOGIC ---
//   const handleEdit = (id) => {
//     // Find the student by ID
//     const studentToEdit = registrations.find((s) => s.id === id)
//     if (studentToEdit) {
//       // Set the default values based on your Go struct
//       setEditingStudent({
//         id: studentToEdit.id,
//         course_code: studentToEdit.course_code || '',
//         name: studentToEdit.name || '',
//         father_name: studentToEdit.father_name || '',
//         phone_number: studentToEdit.phone_number || '',
//         address: studentToEdit.address || '',
//         college: studentToEdit.college || '',
//         course_year: studentToEdit.course_year || '',
//         registration_fee: studentToEdit.registration_fee || 0,
//         fee: studentToEdit.fee || 0,
//         gender: studentToEdit.gender || '',
//         gender_discount: studentToEdit.gender_discount || 0,
//         discount: studentToEdit.discount || 0,
//         training_mode: studentToEdit.training_mode || '',
//       })
//       setIsEditModalOpen(true)
//     }
//   }

//   // Handle Input Changes for the form
//   const handleEditChange = (e) => {
//     const { name, value, type } = e.target
//     setEditingStudent((prev) => ({
//       ...prev,
//       // For numbers, parse them to match backend int64 expectation
//       [name]: type === 'number' ? Number(value) : value,
//     }))
//   }

//   // Submit the Update Request
//   const submitUpdate = async (e) => {
//     e.preventDefault()
//     setIsUpdating(true)
//     try {
//       // Assuming you have this function in your api.js (see instructions below)
//       await api.updateSummerRegistration(editingStudent.id, editingStudent)

//       toast.success('Registration updated successfully!')
//       setIsEditModalOpen(false)
//       loadDashboardData() // Refresh table data
//     } catch (err) {
//       console.error('Error updating registration:', err)
//       toast.error('Failed to update registration. Please check console.')
//     } finally {
//       setIsUpdating(false)
//     }
//   }

//   // --- Dashboard Stats Calculations ---
//   const totalStudents = registrations.length
//   const totalPaidStudents = registrations.filter(
//     (student) => student.status?.toLowerCase() === 'paid',
//   ).length
//   const totalPaidRegFee = registrations.reduce((sum, student) => {
//     if (student.status?.toLowerCase() === 'paid') {
//       return sum + (Number(student.registration_fee) || 0)
//     }
//     return sum
//   }, 0)

//   return (
//     <div className='min-h-screen bg-gray-50 p-3 sm:p-4 md:p-6 lg:p-8 relative'>
//       <div className='max-w-[1600px] mx-auto'>
//         {/* Header Section */}
//         <div className='mb-6 md:mb-8 flex flex-col md:flex-row justify-between items-start md:items-center gap-4'>
//           <div>
//             <h1 className='text-2xl md:text-3xl font-bold text-gray-800 flex items-center gap-3'>
//               <Activity className='text-blue-600' size={32} />
//               Summer Registration Dashboard
//             </h1>
//             <p className='text-sm sm:text-base text-gray-600 mt-1'>
//               View and manage all summer course student registrations.
//             </p>
//           </div>

//           <div className='flex flex-wrap items-center gap-2 w-full md:w-auto'>
//             <button
//               onClick={downloadCSV}
//               disabled={filteredRegistrations.length === 0}
//               className='px-4 py-2 bg-green-600 hover:bg-green-700 text-white rounded-lg shadow-sm font-medium transition flex items-center gap-2 disabled:opacity-50'
//             >
//               <Download size={18} />
//               Export CSV
//             </button>

//             <button
//               onClick={loadDashboardData}
//               className='px-4 py-2 bg-white border border-gray-300 rounded-lg shadow-sm hover:bg-gray-50 text-gray-700 font-medium transition flex items-center gap-2'
//             >
//               {loading ? 'Refreshing...' : 'Refresh Data'}
//             </button>
//           </div>
//         </div>

//         {/* Top Summary Cards */}
//         <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 mb-8'>
//           <div className='bg-white rounded-xl shadow-sm border border-gray-100 p-5 flex items-center gap-4 hover:shadow-md transition-shadow'>
//             <div className='p-3 bg-blue-100 text-blue-600 rounded-lg'>
//               <Users size={24} />
//             </div>
//             <div>
//               <p className='text-sm text-gray-500 font-medium'>
//                 Total Registrations
//               </p>
//               <h3 className='text-xl md:text-2xl font-bold text-gray-800'>
//                 {loading ? '...' : totalStudents}
//               </h3>
//             </div>
//           </div>
//           <div className='bg-white rounded-xl shadow-sm border border-gray-100 p-5 flex items-center gap-4 hover:shadow-md transition-shadow'>
//             <div className='p-3 bg-green-100 text-green-600 rounded-lg'>
//               <IndianRupee size={24} />
//             </div>
//             <div>
//               <p className='text-sm text-gray-500 font-medium'>
//                 Reg. Fee Collection (Paid)
//               </p>
//               <h3 className='text-xl md:text-2xl font-bold text-gray-800'>
//                 {loading
//                   ? '...'
//                   : `₹${totalPaidRegFee.toLocaleString('en-IN')}`}
//               </h3>
//             </div>
//           </div>
//           <div className='bg-white rounded-xl shadow-sm border border-gray-100 p-5 flex items-center gap-4 hover:shadow-md transition-shadow'>
//             <div className='p-3 bg-indigo-100 text-indigo-600 rounded-lg'>
//               <UserCheck size={24} />
//             </div>
//             <div>
//               <p className='text-sm text-gray-500 font-medium'>
//                 Total Paid Reg.
//               </p>
//               <h3 className='text-xl md:text-2xl font-bold text-gray-800'>
//                 {loading ? '...' : totalPaidStudents}
//               </h3>
//             </div>
//           </div>
//         </div>

//         {/* Main Content Area */}
//         <div className='bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden'>
//           {/* Table Toolbar */}
//           <div className='p-4 md:p-6 border-b border-gray-200 flex flex-col lg:flex-row justify-between items-start lg:items-center gap-4 bg-gray-50/50'>
//             <h2 className='text-lg font-semibold text-gray-800 shrink-0'>
//               Recent Registrations
//             </h2>
//             <div className='flex flex-col sm:flex-row items-center gap-3 w-full lg:w-auto'>
//               <div className='relative w-full sm:w-auto'>
//                 <Filter
//                   className='absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400'
//                   size={16}
//                 />
//                 <select
//                   value={statusFilter}
//                   onChange={(e) => setStatusFilter(e.target.value)}
//                   className='w-full sm:w-auto pl-9 pr-8 py-2 border border-gray-300 rounded-lg bg-white text-gray-700 text-sm focus:ring-2 focus:ring-blue-500 outline-none appearance-none cursor-pointer'
//                 >
//                   <option value='all'>All Status</option>
//                   <option value='paid'>Paid Only</option>
//                   <option value='created'>Created / Pending</option>
//                 </select>
//               </div>
//               <select
//                 value={modeFilter}
//                 onChange={(e) => setModeFilter(e.target.value)}
//                 className='w-full sm:w-auto px-4 py-2 border border-gray-300 rounded-lg bg-white text-gray-700 text-sm focus:ring-2 focus:ring-blue-500 outline-none cursor-pointer'
//               >
//                 <option value='all'>All Modes</option>
//                 <option value='online'>Online</option>
//                 <option value='offline'>Offline</option>
//               </select>
//               <div className='relative w-full sm:w-72'>
//                 <Search
//                   className='absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400'
//                   size={18}
//                 />
//                 <input
//                   type='text'
//                   placeholder='Search records...'
//                   value={searchTerm}
//                   onChange={(e) => setSearchTerm(e.target.value)}
//                   className='w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none text-sm'
//                 />
//               </div>
//             </div>
//           </div>

//           {/* Data Table */}
//           <div className='overflow-x-auto'>
//             {loading ? (
//               <div className='p-16 text-center text-gray-500 flex flex-col items-center justify-center min-h-[300px]'>
//                 <div className='animate-spin rounded-full h-10 w-10 border-b-2 border-blue-600 mb-4'></div>
//                 <p className='text-lg'>Loading dashboard data...</p>
//               </div>
//             ) : error ? (
//               <div className='p-12 text-center text-red-500'>
//                 <p>{error}</p>
//                 <button
//                   onClick={loadDashboardData}
//                   className='mt-4 px-4 py-2 bg-red-100 hover:bg-red-200 text-red-700 rounded-lg transition'
//                 >
//                   Try Again
//                 </button>
//               </div>
//             ) : (
//               <table className='w-full text-left border-collapse whitespace-nowrap min-w-[1100px]'>
//                 <thead>
//                   <tr className='bg-gray-100 border-b border-gray-200'>
//                     <th className='p-4 text-sm font-semibold text-gray-600 w-12 text-center'>
//                       S.No
//                     </th>
//                     <th className='p-4 text-sm font-semibold text-gray-600'>
//                       Student Details
//                     </th>
//                     <th className='p-4 text-sm font-semibold text-gray-600'>
//                       Personal Info
//                     </th>
//                     <th className='p-4 text-sm font-semibold text-gray-600'>
//                       Course Info
//                     </th>
//                     <th className='p-4 text-sm font-semibold text-gray-600'>
//                       Financial Details (₹)
//                     </th>
//                     <th className='p-4 text-sm font-semibold text-gray-600'>
//                       Date & Status
//                     </th>
//                     <th className='p-4 text-sm font-semibold text-gray-600 text-center'>
//                       Actions
//                     </th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {currentItems.length === 0 ? (
//                     <tr>
//                       <td
//                         colSpan={7}
//                         className='p-12 text-center text-gray-500'
//                       >
//                         <p className='text-lg'>
//                           No registrations match your filters.
//                         </p>
//                       </td>
//                     </tr>
//                   ) : (
//                     currentItems.map((student, index) => {
//                       const serialNumber = indexOfFirstItem + index + 1
//                       return (
//                         <tr
//                           key={student.id}
//                           className='border-b border-gray-100 hover:bg-indigo-50/50 transition'
//                         >
//                           <td className='p-4 text-center text-sm font-bold text-gray-500'>
//                             {serialNumber}
//                           </td>
//                           <td className='p-4'>
//                             <div className='font-bold text-gray-800 capitalize'>
//                               {student.name}
//                             </div>
//                             <div className='text-xs text-gray-500 font-mono mt-1'>
//                               Reg:{' '}
//                               <span className='text-indigo-600 font-bold'>
//                                 {student.registration_no}
//                               </span>
//                             </div>
//                             <div className='text-xs text-gray-500 mt-1 capitalize'>
//                               Gender: {student.gender}
//                             </div>
//                           </td>
//                           <td className='p-4'>
//                             <div className='text-sm text-gray-800'>
//                               📱 {student.phone_number}
//                             </div>
//                             <div className='text-xs text-gray-500 mt-1 capitalize'>
//                               F: {student.father_name}
//                             </div>
//                             <div
//                               className='text-xs text-gray-500 mt-1 max-w-[180px] truncate capitalize'
//                               title={student.college}
//                             >
//                               🏛️ {student.college} (Yr: {student.course_year})
//                             </div>
//                           </td>
//                           <td className='p-4'>
//                             <span className='px-3 py-1 bg-indigo-100 text-indigo-700 rounded-md text-xs font-bold uppercase border border-indigo-200'>
//                               {student.course_code}
//                             </span>
//                             <div className='text-xs font-medium text-gray-500 mt-2'>
//                               Mode:{' '}
//                               <span
//                                 className={`capitalize ${student.training_mode?.toLowerCase() === 'online' ? 'text-green-600' : 'text-orange-600'}`}
//                               >
//                                 {student.training_mode}
//                               </span>
//                             </div>
//                           </td>
//                           <td className='p-4'>
//                             <div className='text-sm font-bold text-gray-800'>
//                               Reg Fee: ₹{student.registration_fee || 0}
//                             </div>
//                             <div className='text-xs text-gray-500 mt-1'>
//                               Total Fee: ₹
//                               {(student.fee || 0).toLocaleString('en-IN')}
//                             </div>
//                           </td>
//                           <td className='p-4'>
//                             <div className='text-sm text-gray-600'>
//                               {new Date(student.created_at).toLocaleDateString(
//                                 'en-IN',
//                                 {
//                                   day: '2-digit',
//                                   month: 'short',
//                                   year: 'numeric',
//                                 },
//                               )}
//                             </div>
//                             <div className='mt-2'>
//                               <span
//                                 className={`px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider ${student.status?.toLowerCase() === 'paid' ? 'bg-green-100 text-green-700 border border-green-200' : 'bg-yellow-100 text-yellow-700 border border-yellow-200'}`}
//                               >
//                                 {student.status || 'Pending'}
//                               </span>
//                             </div>
//                           </td>
//                           <td className='p-4 text-center'>
//                             <div className='flex items-center justify-center gap-2'>
//                               <button
//                                 onClick={() =>
//                                   navigate(`/summerRegistration/${student.id}`)
//                                 }
//                                 className='px-2 py-1.5 bg-blue-50 text-blue-600 hover:bg-blue-100 hover:text-blue-700 rounded-md transition-colors flex items-center gap-1 border border-blue-200'
//                                 title='See Details'
//                               >
//                                 <Eye size={16} />{' '}
//                                 <span className='text-xs font-medium'>
//                                   Details
//                                 </span>
//                               </button>
//                               <button
//                                 onClick={() => handleEdit(student.id)}
//                                 className='px-2 py-1.5 bg-gray-50 text-gray-600 hover:bg-gray-100 hover:text-gray-800 rounded-md transition-colors flex items-center gap-1 border border-gray-200'
//                                 title='Edit'
//                               >
//                                 <Edit size={16} />{' '}
//                                 <span className='text-xs font-medium'>
//                                   Edit
//                                 </span>
//                               </button>
//                             </div>
//                           </td>
//                         </tr>
//                       )
//                     })
//                   )}
//                 </tbody>
//               </table>
//             )}
//           </div>

//           {/* Pagination Footer */}
//           {!loading && filteredRegistrations.length > 0 && (
//             <div className='bg-white px-4 py-4 border-t border-gray-200 flex items-center justify-between sm:px-6'>
//               <div className='flex-1 flex justify-between sm:hidden'>
//                 <button
//                   onClick={handlePrevPage}
//                   disabled={currentPage === 1}
//                   className='relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50'
//                 >
//                   Previous
//                 </button>
//                 <button
//                   onClick={handleNextPage}
//                   disabled={currentPage === totalPages}
//                   className='ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50'
//                 >
//                   Next
//                 </button>
//               </div>
//               <div className='hidden sm:flex-1 sm:flex sm:items-center sm:justify-between'>
//                 <div>
//                   <p className='text-sm text-gray-700'>
//                     Showing{' '}
//                     <span className='font-medium'>{indexOfFirstItem + 1}</span>{' '}
//                     to{' '}
//                     <span className='font-medium'>
//                       {Math.min(indexOfLastItem, filteredRegistrations.length)}
//                     </span>{' '}
//                     of{' '}
//                     <span className='font-medium'>
//                       {filteredRegistrations.length}
//                     </span>{' '}
//                     results
//                   </p>
//                 </div>
//                 <div>
//                   <nav className='relative z-0 inline-flex rounded-md shadow-sm -space-x-px'>
//                     <button
//                       onClick={handlePrevPage}
//                       disabled={currentPage === 1}
//                       className='relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 disabled:opacity-50'
//                     >
//                       <ChevronLeft className='h-5 w-5' />
//                     </button>
//                     <span className='relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700'>
//                       Page {currentPage} of {totalPages}
//                     </span>
//                     <button
//                       onClick={handleNextPage}
//                       disabled={currentPage === totalPages}
//                       className='relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 disabled:opacity-50'
//                     >
//                       <ChevronRight className='h-5 w-5' />
//                     </button>
//                   </nav>
//                 </div>
//               </div>
//             </div>
//           )}
//         </div>
//       </div>

//       {/* --- EDIT MODAL (POPUP) --- */}
//       {isEditModalOpen && editingStudent && (
//         <div className='fixed inset-0 bg-black/50 z-50 flex justify-center items-center p-4'>
//           <div className='bg-white rounded-xl shadow-2xl w-full max-w-4xl max-h-[90vh] overflow-y-auto flex flex-col'>
//             {/* Modal Header */}
//             <div className='flex justify-between items-center p-6 border-b border-gray-200 sticky top-0 bg-white z-10'>
//               <h2 className='text-xl font-bold text-gray-800 flex items-center gap-2'>
//                 <Edit size={20} className='text-blue-600' /> Update Registration
//               </h2>
//               <button
//                 onClick={() => setIsEditModalOpen(false)}
//                 className='text-gray-400 hover:text-red-500 transition'
//               >
//                 <X size={24} />
//               </button>
//             </div>

//             {/* Modal Form */}
//             <form onSubmit={submitUpdate} className='p-6'>
//               <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5'>
//                 {/* Name */}
//                 <div>
//                   <label className='block text-sm font-medium text-gray-700 mb-1'>
//                     Student Name
//                   </label>
//                   <input
//                     type='text'
//                     name='name'
//                     value={editingStudent.name}
//                     onChange={handleEditChange}
//                     required
//                     className='w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring-blue-500 focus:border-blue-500 outline-none'
//                   />
//                 </div>

//                 {/* Father Name */}
//                 <div>
//                   <label className='block text-sm font-medium text-gray-700 mb-1'>
//                     Father's Name
//                   </label>
//                   <input
//                     type='text'
//                     name='father_name'
//                     value={editingStudent.father_name}
//                     onChange={handleEditChange}
//                     required
//                     className='w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring-blue-500 focus:border-blue-500 outline-none'
//                   />
//                 </div>

//                 {/* Phone */}
//                 <div>
//                   <label className='block text-sm font-medium text-gray-700 mb-1'>
//                     Phone Number
//                   </label>
//                   <input
//                     type='text'
//                     name='phone_number'
//                     value={editingStudent.phone_number}
//                     onChange={handleEditChange}
//                     required
//                     className='w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring-blue-500 focus:border-blue-500 outline-none'
//                   />
//                 </div>

//                 {/* Course Code */}
//                 <div>
//                   <label className='block text-sm font-medium text-gray-700 mb-1'>
//                     Course Code
//                   </label>
//                   <input
//                     type='text'
//                     name='course_code'
//                     value={editingStudent.course_code}
//                     onChange={handleEditChange}
//                     required
//                     className='w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring-blue-500 focus:border-blue-500 outline-none uppercase'
//                   />
//                 </div>

//                 {/* College */}
//                 <div>
//                   <label className='block text-sm font-medium text-gray-700 mb-1'>
//                     College
//                   </label>
//                   <input
//                     type='text'
//                     name='college'
//                     value={editingStudent.college}
//                     onChange={handleEditChange}
//                     required
//                     className='w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring-blue-500 focus:border-blue-500 outline-none'
//                   />
//                 </div>

//                 {/* Course Year */}
//                 <div>
//                   <label className='block text-sm font-medium text-gray-700 mb-1'>
//                     Course Year
//                   </label>
//                   <input
//                     type='text'
//                     name='course_year'
//                     value={editingStudent.course_year}
//                     onChange={handleEditChange}
//                     placeholder='e.g. 1st, 2nd, 3rd'
//                     className='w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring-blue-500 focus:border-blue-500 outline-none'
//                   />
//                 </div>

//                 {/* Gender */}
//                 <div>
//                   <label className='block text-sm font-medium text-gray-700 mb-1'>
//                     Gender
//                   </label>
//                   <select
//                     name='gender'
//                     value={editingStudent.gender}
//                     onChange={handleEditChange}
//                     className='w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring-blue-500 focus:border-blue-500 outline-none bg-white'
//                   >
//                     <option value=''>Select Gender</option>
//                     <option value='Male'>Male</option>
//                     <option value='Female'>Female</option>
//                     <option value='Other'>Other</option>
//                   </select>
//                 </div>

//                 {/* Training Mode */}
//                 <div>
//                   <label className='block text-sm font-medium text-gray-700 mb-1'>
//                     Training Mode
//                   </label>
//                   <select
//                     name='training_mode'
//                     value={editingStudent.training_mode}
//                     onChange={handleEditChange}
//                     className='w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring-blue-500 focus:border-blue-500 outline-none bg-white'
//                   >
//                     <option value='online'>Online</option>
//                     <option value='offline'>Offline</option>
//                   </select>
//                 </div>

//                 {/* Registration Fee */}
//                 <div>
//                   <label className='block text-sm font-medium text-gray-700 mb-1'>
//                     Registration Fee (₹)
//                   </label>
//                   <input
//                     type='number'
//                     name='registration_fee'
//                     value={editingStudent.registration_fee}
//                     onChange={handleEditChange}
//                     required
//                     min='0'
//                     className='w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring-blue-500 focus:border-blue-500 outline-none'
//                   />
//                 </div>

//                 {/* Total Fee */}
//                 <div>
//                   <label className='block text-sm font-medium text-gray-700 mb-1'>
//                     Total Fee (₹)
//                   </label>
//                   <input
//                     type='number'
//                     name='fee'
//                     value={editingStudent.fee}
//                     onChange={handleEditChange}
//                     required
//                     min='0'
//                     className='w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring-blue-500 focus:border-blue-500 outline-none'
//                   />
//                 </div>

//                 {/* Discount */}
//                 <div>
//                   <label className='block text-sm font-medium text-gray-700 mb-1'>
//                     Discount (₹)
//                   </label>
//                   <input
//                     type='number'
//                     name='discount'
//                     value={editingStudent.discount}
//                     onChange={handleEditChange}
//                     min='0'
//                     className='w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring-blue-500 focus:border-blue-500 outline-none'
//                   />
//                 </div>

//                 {/* Gender Discount */}
//                 <div>
//                   <label className='block text-sm font-medium text-gray-700 mb-1'>
//                     Gender Discount (₹)
//                   </label>
//                   <input
//                     type='number'
//                     name='gender_discount'
//                     value={editingStudent.gender_discount}
//                     onChange={handleEditChange}
//                     min='0'
//                     className='w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring-blue-500 focus:border-blue-500 outline-none'
//                   />
//                 </div>

//                 {/* Address (Full width) */}
//                 <div className='md:col-span-2 lg:col-span-3'>
//                   <label className='block text-sm font-medium text-gray-700 mb-1'>
//                     Address
//                   </label>
//                   <textarea
//                     name='address'
//                     value={editingStudent.address}
//                     onChange={handleEditChange}
//                     rows='2'
//                     className='w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring-blue-500 focus:border-blue-500 outline-none resize-none'
//                   ></textarea>
//                 </div>
//               </div>

//               {/* Modal Footer Buttons */}
//               <div className='mt-8 flex justify-end gap-3 pt-4 border-t border-gray-200'>
//                 <button
//                   type='button'
//                   onClick={() => setIsEditModalOpen(false)}
//                   className='px-5 py-2 border border-gray-300 bg-white text-gray-700 rounded-lg hover:bg-gray-50 transition'
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   type='submit'
//                   disabled={isUpdating}
//                   className='px-5 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition disabled:opacity-50 flex items-center gap-2'
//                 >
//                   {isUpdating ? 'Saving...' : 'Save Changes'}
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}
//     </div>
//   )
// }

// export default SummerDashboard
import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import * as api from '../../../app/axios/api'
import { toast } from 'sonner'

import {
  Users,
  IndianRupee,
  Activity,
  Search,
  ChevronLeft,
  ChevronRight,
  Eye,
  Edit,
  UserCheck,
  Filter,
  Download,
  X, // Close icon for modal
} from 'lucide-react'

const SummerDashboard = () => {
  const navigate = useNavigate()

  const [registrations, setRegistrations] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  // Filters, Search, aur Pagination States
  const [searchTerm, setSearchTerm] = useState('')
  const [statusFilter, setStatusFilter] = useState('all')
  const [modeFilter, setModeFilter] = useState('all')
  // NEW: Add state for Course Code and Course Year filters
  const [courseCodeFilter, setCourseCodeFilter] = useState('all')
  const [courseYearFilter, setCourseYearFilter] = useState('all')

  const [currentPage, setCurrentPage] = useState(1)
  const itemsPerPage = 20

  // --- EDIT MODAL STATES ---
  const [isEditModalOpen, setIsEditModalOpen] = useState(false)
  const [editingStudent, setEditingStudent] = useState(null)
  const [isUpdating, setIsUpdating] = useState(false)

  // API Call
  const loadDashboardData = async () => {
    setLoading(true)
    setError(null)
    try {
      const res = await api.fetchSummerDashboard()
      setRegistrations(res.data || [])
    } catch (err) {
      console.error('Error fetching summer dashboard:', err)
      setError('Failed to load registration data. Please try again later.')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    loadDashboardData()
  }, [])

  useEffect(() => {
    setCurrentPage(1)
  }, [searchTerm, statusFilter, modeFilter, courseCodeFilter, courseYearFilter]) // NEW: Add new filters to dependency array

  // --- Dynamic Filter Options ---
  const uniqueCourseCodes = Array.from(
    new Set(registrations.map((s) => s.course_code).filter(Boolean)),
  ).sort()
  const uniqueCourseYears = Array.from(
    new Set(registrations.map((s) => s.course_year).filter(Boolean)),
  ).sort((a, b) => {
    // Basic numeric sort if years are numbers, otherwise string sort
    const numA = parseInt(a)
    const numB = parseInt(b)
    if (!isNaN(numA) && !isNaN(numB)) {
      return numA - numB
    }
    return a.localeCompare(b)
  })

  // --- Search & Filter Logic ---
  const filteredRegistrations = registrations.filter((student) => {
    const searchString = searchTerm.toLowerCase()
    const matchesSearch =
      student.name?.toLowerCase().includes(searchString) ||
      student.course_code?.toLowerCase().includes(searchString) ||
      student.phone_number?.includes(searchString) ||
      student.registration_no?.toLowerCase().includes(searchString) ||
      student.college?.toLowerCase().includes(searchString) ||
      student.razorpay_payment_id?.toLowerCase().includes(searchString)

    const matchesStatus =
      statusFilter === 'all' || student.status?.toLowerCase() === statusFilter

    const matchesMode =
      modeFilter === 'all' ||
      student.training_mode?.toLowerCase() === modeFilter

    // NEW: Add Course Code Filter
    const matchesCourseCode =
      courseCodeFilter === 'all' ||
      student.course_code?.toLowerCase() === courseCodeFilter.toLowerCase()

    // NEW: Add Course Year Filter
    const matchesCourseYear =
      courseYearFilter === 'all' ||
      student.course_year?.toLowerCase() === courseYearFilter.toLowerCase()

    return (
      matchesSearch &&
      matchesStatus &&
      matchesMode &&
      matchesCourseCode && // NEW: Include in return
      matchesCourseYear // NEW: Include in return
    )
  })

  // --- CSV Export Logic ---
  const downloadCSV = () => {
    if (filteredRegistrations.length === 0) {
      alert('No data available to download')
      return
    }

    const headers = [
      'Student Name',
      'Registration No',
      'Phone Number',
      'Father Name',
      'Course Code',
      'Mode',
      'Registration Fee',
      'Total Fee',
      'Date',
      'Status',
      'Gender',
      'College', // Added College to CSV
      'Course Year', // Added Course Year to CSV
    ]

    const rows = filteredRegistrations.map((student) => [
      student.name || '',
      student.registration_no || '',
      student.phone_number || '',
      student.father_name || '',
      student.course_code || '',
      student.training_mode || '',
      student.registration_fee || 0,
      student.fee || 0,
      new Date(student.created_at).toLocaleDateString('en-IN', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
      }),
      student.status || 'Pending',
      student.gender || '',
      student.college || '', // Added College
      student.course_year || '', // Added Course Year
    ])

    const csvContent = [
      headers.join(','),
      ...rows.map((row) => row.map((value) => `"${value}"`).join(',')),
    ].join('\n')

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
    const url = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.setAttribute('href', url)
    link.setAttribute(
      'download',
      `Summer_Registrations_${new Date().toISOString().split('T')[0]}.csv`,
    )
    link.style.visibility = 'hidden'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  // --- Pagination Logic ---
  const indexOfLastItem = currentPage * itemsPerPage
  const indexOfFirstItem = indexOfLastItem - itemsPerPage
  const currentItems = filteredRegistrations.slice(
    indexOfFirstItem,
    indexOfLastItem,
  )
  const totalPages = Math.ceil(filteredRegistrations.length / itemsPerPage)

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage((prev) => prev + 1)
  }
  const handlePrevPage = () => {
    if (currentPage > 1) setCurrentPage((prev) => prev - 1)
  }

  // --- EDIT MODAL LOGIC ---
  const handleEdit = (id) => {
    // Find the student by ID
    const studentToEdit = registrations.find((s) => s.id === id)
    if (studentToEdit) {
      // Set the default values based on your Go struct
      setEditingStudent({
        id: studentToEdit.id,
        course_code: studentToEdit.course_code || '',
        name: studentToEdit.name || '',
        father_name: studentToEdit.father_name || '',
        phone_number: studentToEdit.phone_number || '',
        address: studentToEdit.address || '',
        college: studentToEdit.college || '',
        course_year: studentToEdit.course_year || '',
        registration_fee: studentToEdit.registration_fee || 0,
        fee: studentToEdit.fee || 0,
        gender: studentToEdit.gender || '',
        gender_discount: studentToEdit.gender_discount || 0,
        discount: studentToEdit.discount || 0,
        training_mode: studentToEdit.training_mode || '',
      })
      setIsEditModalOpen(true)
    }
  }

  // Handle Input Changes for the form
  const handleEditChange = (e) => {
    const { name, value, type } = e.target
    setEditingStudent((prev) => ({
      ...prev,
      // For numbers, parse them to match backend int64 expectation
      [name]: type === 'number' ? Number(value) : value,
    }))
  }

  // Submit the Update Request
  const submitUpdate = async (e) => {
    e.preventDefault()
    setIsUpdating(true)
    try {
      // Assuming you have this function in your api.js (see instructions below)
      await api.updateSummerRegistration(editingStudent.id, editingStudent)

      toast.success('Registration updated successfully!')
      setIsEditModalOpen(false)
      loadDashboardData() // Refresh table data
    } catch (err) {
      console.error('Error updating registration:', err)
      toast.error('Failed to update registration. Please check console.')
    } finally {
      setIsUpdating(false)
    }
  }

  // --- Dashboard Stats Calculations ---
  const totalStudents = registrations.length
  const totalPaidStudents = registrations.filter(
    (student) => student.status?.toLowerCase() === 'paid',
  ).length
  const totalPaidRegFee = registrations.reduce((sum, student) => {
    if (student.status?.toLowerCase() === 'paid') {
      return sum + (Number(student.registration_fee) || 0)
    }
    return sum
  }, 0)

  return (
    <div className='min-h-screen bg-gray-50 p-3 sm:p-4 md:p-6 lg:p-8 relative'>
      <div className='max-w-[1600px] mx-auto'>
        {/* Header Section */}
        <div className='mb-6 md:mb-8 flex flex-col md:flex-row justify-between items-start md:items-center gap-4'>
          <div>
            <h1 className='text-2xl md:text-3xl font-bold text-gray-800 flex items-center gap-3'>
              <Activity className='text-blue-600' size={32} />
              Summer Registration Dashboard
            </h1>
            <p className='text-sm sm:text-base text-gray-600 mt-1'>
              View and manage all summer course student registrations.
            </p>
          </div>

          <div className='flex flex-wrap items-center gap-2 w-full md:w-auto'>
            <button
              onClick={downloadCSV}
              disabled={filteredRegistrations.length === 0}
              className='px-4 py-2 bg-green-600 hover:bg-green-700 text-white rounded-lg shadow-sm font-medium transition flex items-center gap-2 disabled:opacity-50'
            >
              <Download size={18} />
              Export CSV
            </button>

            <button
              onClick={loadDashboardData}
              className='px-4 py-2 bg-white border border-gray-300 rounded-lg shadow-sm hover:bg-gray-50 text-gray-700 font-medium transition flex items-center gap-2'
            >
              {loading ? 'Refreshing...' : 'Refresh Data'}
            </button>
          </div>
        </div>

        {/* Top Summary Cards */}
        <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 mb-8'>
          <div className='bg-white rounded-xl shadow-sm border border-gray-100 p-5 flex items-center gap-4 hover:shadow-md transition-shadow'>
            <div className='p-3 bg-blue-100 text-blue-600 rounded-lg'>
              <Users size={24} />
            </div>
            <div>
              <p className='text-sm text-gray-500 font-medium'>
                Total Registrations
              </p>
              <h3 className='text-xl md:text-2xl font-bold text-gray-800'>
                {loading ? '...' : totalStudents}
              </h3>
            </div>
          </div>
          <div className='bg-white rounded-xl shadow-sm border border-gray-100 p-5 flex items-center gap-4 hover:shadow-md transition-shadow'>
            <div className='p-3 bg-green-100 text-green-600 rounded-lg'>
              <IndianRupee size={24} />
            </div>
            <div>
              <p className='text-sm text-gray-500 font-medium'>
                Reg. Fee Collection (Paid)
              </p>
              <h3 className='text-xl md:text-2xl font-bold text-gray-800'>
                {loading
                  ? '...'
                  : `₹${totalPaidRegFee.toLocaleString('en-IN')}`}
              </h3>
            </div>
          </div>
          <div className='bg-white rounded-xl shadow-sm border border-gray-100 p-5 flex items-center gap-4 hover:shadow-md transition-shadow'>
            <div className='p-3 bg-indigo-100 text-indigo-600 rounded-lg'>
              <UserCheck size={24} />
            </div>
            <div>
              <p className='text-sm text-gray-500 font-medium'>
                Total Paid Reg.
              </p>
              <h3 className='text-xl md:text-2xl font-bold text-gray-800'>
                {loading ? '...' : totalPaidStudents}
              </h3>
            </div>
          </div>
        </div>

        {/* Main Content Area */}
        <div className='bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden'>
          {/* Table Toolbar */}
          <div className='p-4 md:p-6 border-b border-gray-200 flex flex-col lg:flex-row justify-between items-start lg:items-center gap-4 bg-gray-50/50'>
            <h2 className='text-lg font-semibold text-gray-800 shrink-0'>
              Recent Registrations
            </h2>
            <div className='flex flex-col sm:flex-row items-center gap-3 w-full lg:w-auto'>
              {/* Status Filter */}
              <div className='relative w-full sm:w-auto'>
                <Filter
                  className='absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400'
                  size={16}
                />
                <select
                  value={statusFilter}
                  onChange={(e) => setStatusFilter(e.target.value)}
                  className='w-full sm:w-auto pl-9 pr-8 py-2 border border-gray-300 rounded-lg bg-white text-gray-700 text-sm focus:ring-2 focus:ring-blue-500 outline-none appearance-none cursor-pointer'
                >
                  <option value='all'>All Status</option>
                  <option value='paid'>Paid Only</option>
                  <option value='created'>Created / Pending</option>
                </select>
              </div>

              {/* Mode Filter */}
              <select
                value={modeFilter}
                onChange={(e) => setModeFilter(e.target.value)}
                className='w-full sm:w-auto px-4 py-2 border border-gray-300 rounded-lg bg-white text-gray-700 text-sm focus:ring-2 focus:ring-blue-500 outline-none cursor-pointer'
              >
                <option value='all'>All Modes</option>
                <option value='online'>Online</option>
                <option value='offline'>Offline</option>
              </select>

              {/* NEW: Course Code Filter */}
              <select
                value={courseCodeFilter}
                onChange={(e) => setCourseCodeFilter(e.target.value)}
                className='w-full sm:w-auto px-4 py-2 border border-gray-300 rounded-lg bg-white text-gray-700 text-sm focus:ring-2 focus:ring-blue-500 outline-none cursor-pointer'
              >
                <option value='all'>All Course Codes</option>
                {uniqueCourseCodes.map((code) => (
                  <option key={code} value={code.toLowerCase()}>
                    {code.toUpperCase()}
                  </option>
                ))}
              </select>

              {/* NEW: Course Year Filter */}
              <select
                value={courseYearFilter}
                onChange={(e) => setCourseYearFilter(e.target.value)}
                className='w-full sm:w-auto px-4 py-2 border border-gray-300 rounded-lg bg-white text-gray-700 text-sm focus:ring-2 focus:ring-blue-500 outline-none cursor-pointer'
              >
                <option value='all'>All Course Years</option>
                {uniqueCourseYears.map((year) => (
                  <option key={year} value={year.toLowerCase()}>
                    {year}
                  </option>
                ))}
              </select>

              {/* Search Input */}
              <div className='relative w-full sm:w-72'>
                <Search
                  className='absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400'
                  size={18}
                />
                <input
                  type='text'
                  placeholder='Search records...'
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className='w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none text-sm'
                />
              </div>
            </div>
          </div>

          {/* Data Table */}
          <div className='overflow-x-auto'>
            {loading ? (
              <div className='p-16 text-center text-gray-500 flex flex-col items-center justify-center min-h-[300px]'>
                <div className='animate-spin rounded-full h-10 w-10 border-b-2 border-blue-600 mb-4'></div>
                <p className='text-lg'>Loading dashboard data...</p>
              </div>
            ) : error ? (
              <div className='p-12 text-center text-red-500'>
                <p>{error}</p>
                <button
                  onClick={loadDashboardData}
                  className='mt-4 px-4 py-2 bg-red-100 hover:bg-red-200 text-red-700 rounded-lg transition'
                >
                  Try Again
                </button>
              </div>
            ) : (
              <table className='w-full text-left border-collapse whitespace-nowrap min-w-[1100px]'>
                <thead>
                  <tr className='bg-gray-100 border-b border-gray-200'>
                    <th className='p-4 text-sm font-semibold text-gray-600 w-12 text-center'>
                      S.No
                    </th>
                    <th className='p-4 text-sm font-semibold text-gray-600'>
                      Student Details
                    </th>
                    <th className='p-4 text-sm font-semibold text-gray-600'>
                      Personal Info
                    </th>
                    <th className='p-4 text-sm font-semibold text-gray-600'>
                      Course Info
                    </th>
                    <th className='p-4 text-sm font-semibold text-gray-600'>
                      Financial Details (₹)
                    </th>
                    <th className='p-4 text-sm font-semibold text-gray-600'>
                      Date & Status
                    </th>
                    <th className='p-4 text-sm font-semibold text-gray-600 text-center'>
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {currentItems.length === 0 ? (
                    <tr>
                      <td
                        colSpan={7}
                        className='p-12 text-center text-gray-500'
                      >
                        <p className='text-lg'>
                          No registrations match your filters.
                        </p>
                      </td>
                    </tr>
                  ) : (
                    currentItems.map((student, index) => {
                      const serialNumber = indexOfFirstItem + index + 1
                      return (
                        <tr
                          key={student.id}
                          className='border-b border-gray-100 hover:bg-indigo-50/50 transition'
                        >
                          <td className='p-4 text-center text-sm font-bold text-gray-500'>
                            {serialNumber}
                          </td>
                          <td className='p-4'>
                            <div className='font-bold text-gray-800 capitalize'>
                              {student.name}
                            </div>
                            <div className='text-xs text-gray-500 font-mono mt-1'>
                              Reg:{' '}
                              <span className='text-indigo-600 font-bold'>
                                {student.registration_no}
                              </span>
                            </div>
                            <div className='text-xs text-gray-500 mt-1 capitalize'>
                              Gender: {student.gender}
                            </div>
                          </td>
                          <td className='p-4'>
                            <div className='text-sm text-gray-800'>
                              📱 {student.phone_number}
                            </div>
                            <div className='text-xs text-gray-500 mt-1 capitalize'>
                              F: {student.father_name}
                            </div>
                            <div
                              className='text-xs text-gray-500 mt-1 max-w-[180px] truncate capitalize'
                              title={student.college}
                            >
                              🏛️ {student.college} (Yr: {student.course_year})
                            </div>
                          </td>
                          <td className='p-4'>
                            <span className='px-3 py-1 bg-indigo-100 text-indigo-700 rounded-md text-xs font-bold uppercase border border-indigo-200'>
                              {student.course_code}
                            </span>
                            <div className='text-xs font-medium text-gray-500 mt-2'>
                              Mode:{' '}
                              <span
                                className={`capitalize ${student.training_mode?.toLowerCase() === 'online' ? 'text-green-600' : 'text-orange-600'}`}
                              >
                                {student.training_mode}
                              </span>
                            </div>
                          </td>
                          <td className='p-4'>
                            <div className='text-sm font-bold text-gray-800'>
                              Reg Fee: ₹{student.registration_fee || 0}
                            </div>
                            <div className='text-xs text-gray-500 mt-1'>
                              Total Fee: ₹
                              {(student.fee || 0).toLocaleString('en-IN')}
                            </div>
                          </td>
                          <td className='p-4'>
                            <div className='text-sm text-gray-600'>
                              {new Date(student.created_at).toLocaleDateString(
                                'en-IN',
                                {
                                  day: '2-digit',
                                  month: 'short',
                                  year: 'numeric',
                                },
                              )}
                            </div>
                            <div className='mt-2'>
                              <span
                                className={`px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider ${student.status?.toLowerCase() === 'paid' ? 'bg-green-100 text-green-700 border border-green-200' : 'bg-yellow-100 text-yellow-700 border border-yellow-200'}`}
                              >
                                {student.status || 'Pending'}
                              </span>
                            </div>
                          </td>
                          <td className='p-4 text-center'>
                            <div className='flex items-center justify-center gap-2'>
                              <button
                                onClick={() =>
                                  navigate(`/summerRegistration/${student.id}`)
                                }
                                className='px-2 py-1.5 bg-blue-50 text-blue-600 hover:bg-blue-100 hover:text-blue-700 rounded-md transition-colors flex items-center gap-1 border border-blue-200'
                                title='See Details'
                              >
                                <Eye size={16} />{' '}
                                <span className='text-xs font-medium'>
                                  Details
                                </span>
                              </button>
                              <button
                                onClick={() => handleEdit(student.id)}
                                className='px-2 py-1.5 bg-gray-50 text-gray-600 hover:bg-gray-100 hover:text-gray-800 rounded-md transition-colors flex items-center gap-1 border border-gray-200'
                                title='Edit'
                              >
                                <Edit size={16} />{' '}
                                <span className='text-xs font-medium'>
                                  Edit
                                </span>
                              </button>
                            </div>
                          </td>
                        </tr>
                      )
                    })
                  )}
                </tbody>
              </table>
            )}
          </div>

          {/* Pagination Footer */}
          {!loading && filteredRegistrations.length > 0 && (
            <div className='bg-white px-4 py-4 border-t border-gray-200 flex items-center justify-between sm:px-6'>
              <div className='flex-1 flex justify-between sm:hidden'>
                <button
                  onClick={handlePrevPage}
                  disabled={currentPage === 1}
                  className='relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50'
                >
                  Previous
                </button>
                <button
                  onClick={handleNextPage}
                  disabled={currentPage === totalPages}
                  className='ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50'
                >
                  Next
                </button>
              </div>
              <div className='hidden sm:flex-1 sm:flex sm:items-center sm:justify-between'>
                <div>
                  <p className='text-sm text-gray-700'>
                    Showing{' '}
                    <span className='font-medium'>{indexOfFirstItem + 1}</span>{' '}
                    to{' '}
                    <span className='font-medium'>
                      {Math.min(indexOfLastItem, filteredRegistrations.length)}
                    </span>{' '}
                    of{' '}
                    <span className='font-medium'>
                      {filteredRegistrations.length}
                    </span>{' '}
                    results
                  </p>
                </div>
                <div>
                  <nav className='relative z-0 inline-flex rounded-md shadow-sm -space-x-px'>
                    <button
                      onClick={handlePrevPage}
                      disabled={currentPage === 1}
                      className='relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 disabled:opacity-50'
                    >
                      <ChevronLeft className='h-5 w-5' />
                    </button>
                    <span className='relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700'>
                      Page {currentPage} of {totalPages}
                    </span>
                    <button
                      onClick={handleNextPage}
                      disabled={currentPage === totalPages}
                      className='relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 disabled:opacity-50'
                    >
                      <ChevronRight className='h-5 w-5' />
                    </button>
                  </nav>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* --- EDIT MODAL (POPUP) --- */}
      {isEditModalOpen && editingStudent && (
        <div className='fixed inset-0 bg-black/50 z-50 flex justify-center items-center p-4'>
          <div className='bg-white rounded-xl shadow-2xl w-full max-w-4xl max-h-[90vh] overflow-y-auto flex flex-col'>
            {/* Modal Header */}
            <div className='flex justify-between items-center p-6 border-b border-gray-200 sticky top-0 bg-white z-10'>
              <h2 className='text-xl font-bold text-gray-800 flex items-center gap-2'>
                <Edit size={20} className='text-blue-600' /> Update Registration
              </h2>
              <button
                onClick={() => setIsEditModalOpen(false)}
                className='text-gray-400 hover:text-red-500 transition'
              >
                <X size={24} />
              </button>
            </div>

            {/* Modal Form */}
            <form onSubmit={submitUpdate} className='p-6'>
              <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5'>
                {/* Name */}
                <div>
                  <label className='block text-sm font-medium text-gray-700 mb-1'>
                    Student Name
                  </label>
                  <input
                    type='text'
                    name='name'
                    value={editingStudent.name}
                    onChange={handleEditChange}
                    required
                    className='w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring-blue-500 focus:border-blue-500 outline-none'
                  />
                </div>

                {/* Father Name */}
                <div>
                  <label className='block text-sm font-medium text-gray-700 mb-1'>
                    Father's Name
                  </label>
                  <input
                    type='text'
                    name='father_name'
                    value={editingStudent.father_name}
                    onChange={handleEditChange}
                    required
                    className='w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring-blue-500 focus:border-blue-500 outline-none'
                  />
                </div>

                {/* Phone */}
                <div>
                  <label className='block text-sm font-medium text-gray-700 mb-1'>
                    Phone Number
                  </label>
                  <input
                    type='text'
                    name='phone_number'
                    value={editingStudent.phone_number}
                    onChange={handleEditChange}
                    required
                    className='w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring-blue-500 focus:border-blue-500 outline-none'
                  />
                </div>

                {/* Course Code */}
                <div>
                  <label className='block text-sm font-medium text-gray-700 mb-1'>
                    Course Code
                  </label>
                  <input
                    type='text'
                    name='course_code'
                    value={editingStudent.course_code}
                    onChange={handleEditChange}
                    required
                    className='w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring-blue-500 focus:border-blue-500 outline-none uppercase'
                  />
                </div>

                {/* College */}
                <div>
                  <label className='block text-sm font-medium text-gray-700 mb-1'>
                    College
                  </label>
                  <input
                    type='text'
                    name='college'
                    value={editingStudent.college}
                    onChange={handleEditChange}
                    required
                    className='w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring-blue-500 focus:border-blue-500 outline-none'
                  />
                </div>

                {/* Course Year */}
                <div>
                  <label className='block text-sm font-medium text-gray-700 mb-1'>
                    Course Year
                  </label>
                  <input
                    type='text'
                    name='course_year'
                    value={editingStudent.course_year}
                    onChange={handleEditChange}
                    placeholder='e.g. 1st, 2nd, 3rd'
                    className='w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring-blue-500 focus:border-blue-500 outline-none'
                  />
                </div>

                {/* Gender */}
                <div>
                  <label className='block text-sm font-medium text-gray-700 mb-1'>
                    Gender
                  </label>
                  <select
                    name='gender'
                    value={editingStudent.gender}
                    onChange={handleEditChange}
                    className='w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring-blue-500 focus:border-blue-500 outline-none bg-white'
                  >
                    <option value=''>Select Gender</option>
                    <option value='Male'>Male</option>
                    <option value='Female'>Female</option>
                    <option value='Other'>Other</option>
                  </select>
                </div>

                {/* Training Mode */}
                <div>
                  <label className='block text-sm font-medium text-gray-700 mb-1'>
                    Training Mode
                  </label>
                  <select
                    name='training_mode'
                    value={editingStudent.training_mode}
                    onChange={handleEditChange}
                    className='w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring-blue-500 focus:border-blue-500 outline-none bg-white'
                  >
                    <option value='online'>Online</option>
                    <option value='offline'>Offline</option>
                  </select>
                </div>

                {/* Registration Fee */}
                <div>
                  <label className='block text-sm font-medium text-gray-700 mb-1'>
                    Registration Fee (₹)
                  </label>
                  <input
                    type='number'
                    name='registration_fee'
                    value={editingStudent.registration_fee}
                    onChange={handleEditChange}
                    required
                    min='0'
                    className='w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring-blue-500 focus:border-blue-500 outline-none'
                  />
                </div>

                {/* Total Fee */}
                <div>
                  <label className='block text-sm font-medium text-gray-700 mb-1'>
                    Total Fee (₹)
                  </label>
                  <input
                    type='number'
                    name='fee'
                    value={editingStudent.fee}
                    onChange={handleEditChange}
                    required
                    min='0'
                    className='w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring-blue-500 focus:border-blue-500 outline-none'
                  />
                </div>

                {/* Discount */}
                <div>
                  <label className='block text-sm font-medium text-gray-700 mb-1'>
                    Discount (₹)
                  </label>
                  <input
                    type='number'
                    name='discount'
                    value={editingStudent.discount}
                    onChange={handleEditChange}
                    min='0'
                    className='w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring-blue-500 focus:border-blue-500 outline-none'
                  />
                </div>

                {/* Gender Discount */}
                <div>
                  <label className='block text-sm font-medium text-gray-700 mb-1'>
                    Gender Discount (₹)
                  </label>
                  <input
                    type='number'
                    name='gender_discount'
                    value={editingStudent.gender_discount}
                    onChange={handleEditChange}
                    min='0'
                    className='w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring-blue-500 focus:border-blue-500 outline-none'
                  />
                </div>

                {/* Address (Full width) */}
                <div className='md:col-span-2 lg:col-span-3'>
                  <label className='block text-sm font-medium text-gray-700 mb-1'>
                    Address
                  </label>
                  <textarea
                    name='address'
                    value={editingStudent.address}
                    onChange={handleEditChange}
                    rows='2'
                    className='w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring-blue-500 focus:border-blue-500 outline-none resize-none'
                  ></textarea>
                </div>
              </div>

              {/* Modal Footer Buttons */}
              <div className='mt-8 flex justify-end gap-3 pt-4 border-t border-gray-200'>
                <button
                  type='button'
                  onClick={() => setIsEditModalOpen(false)}
                  className='px-5 py-2 border border-gray-300 bg-white text-gray-700 rounded-lg hover:bg-gray-50 transition'
                >
                  Cancel
                </button>
                <button
                  type='submit'
                  disabled={isUpdating}
                  className='px-5 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition disabled:opacity-50 flex items-center gap-2'
                >
                  {isUpdating ? 'Saving...' : 'Save Changes'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  )
}

export default SummerDashboard
